import { MONERIS_PAYPAGE } from './index';
import { Action } from '../action';

export class MonerisPaypageInitAction implements Action {
	readonly type = MONERIS_PAYPAGE.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class MonerisPaypageDestroyAction implements Action {
	readonly type = MONERIS_PAYPAGE.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class MonerisPaypageShowIframeAction implements Action {
	readonly type = MONERIS_PAYPAGE.SHOW_IFRAME;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class MonerisPaypageHideIframeAction implements Action {
	readonly type = MONERIS_PAYPAGE.HIDE_IFRAME;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class MonerisPaypageClickRetryAction implements Action {
	readonly type = MONERIS_PAYPAGE.CLICK_RETRY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}
